module.exports = __webpack_public_path__ + "stylesheets/edu_b1dcb536c54af32676283d58448d9fe5.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/edu.less
// module id = TBjL
// module chunks = 118